import Http from "../../http";

class CouponServices {
  static async validate(data) {
console.error(' in the code validate ===========', data);

    return Http.post('/coupon/validate', data);
  }

 

}

export default CouponServices;